import PostOrganisationRequestModelBase from '../_generated/modelBases/post-organisation-request-model-base';

export default class PostOrganisationRequestModel extends PostOrganisationRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
